module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_plus-2b14061fc33781a963b771348f0d4020.svg";